export default cart => cart.map(cartItem => ({
    id: cartItem.product.variant.id,
    name: cartItem.product.name,
    category: `${cartItem.product.productgroup.name}`,
    variant: cartItem.product.variant.name,
    price: cartItem.product.variant.price,
    quantity: cartItem.quantity,
}));
